import React from "react";
import { Item, ItemAttributes } from "../../../../js/parsegenerated";
import DefaultRender from "./columns/DefaultRender";
import SourcesRender from "./columns/SourcesRender";
import StockRender from "./columns/StockRender";

export function DynamicColumn(item: Item, attribute: keyof ItemAttributes) {
  if (Components[attribute])
    return React.createElement(
      Components[attribute],
      { item, attribute },
      null
    );

  return React.createElement(Components.default, { item, attribute }, null);
}

export type RenderProps = {
  item: Item;
  attribute: keyof ItemAttributes;
};

const Components = {
  sources: SourcesRender,
  stock: StockRender,
  default: DefaultRender,
};
